import { render, staticRenderFns } from "./binglePageDescription.vue?vue&type=template&id=7155d375&scoped=true&"
import script from "./binglePageDescription.vue?vue&type=script&lang=js&"
export * from "./binglePageDescription.vue?vue&type=script&lang=js&"
import style0 from "./binglePageDescription.vue?vue&type=style&index=0&id=7155d375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155d375",
  null
  
)

export default component.exports